import React from "react"
import GoogleMapReact from "google-map-react"
import { useTheme } from "@emotion/react"

import { AspectRatio, Box, Heading, Pin, Wrapper } from "components"

const Map = ({ coordinates, headline, title }) => {
  const theme = useTheme()
  const mapOptions = {
    styles: [
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#e9e9e9",
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
          {
            color: "#f5f5f5",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 29,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
          {
            color: "#ffffff",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#f5f5f5",
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            color: "#dedede",
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#ffffff",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        elementType: "labels.text.fill",
        stylers: [
          {
            saturation: 36,
          },
          {
            color: "#333333",
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
          {
            color: "#f2f2f2",
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#fefefe",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#fefefe",
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
    ],
  }

  return (
    <>
      {coordinates && title && (
        <Wrapper>
          {/* ======================== TITLE ======================== */}
          {headline && (
            <Heading size={700} mb="layout.2" textAlign={["left", "center"]}>
              {headline}
            </Heading>
          )}

          {/* ======================== MAP ======================== */}
          <Box
            mx={[-24, 0]}
            mt="layout.3"
            p={[0, "4px"]}
            boxShadow={["none", `inset 0 0 0 4px ${theme.colors.text}`]}
          >
            <AspectRatio ratio="16:9" bg="wash">
              <GoogleMapReact
                bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAPS_KEY }}
                defaultCenter={[coordinates.latitude, coordinates.longitude]}
                defaultZoom={16}
                options={mapOptions}
              >
                <Pin
                  coordinates={[coordinates.latitude, coordinates.longitude]}
                  icon={"mapView"}
                  label={title}
                  color="brand"
                />
              </GoogleMapReact>
            </AspectRatio>
          </Box>
        </Wrapper>
      )}
    </>
  )
}

export default Map
